var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7569 10.0519H23.75V10H12.5V15H19.5644C18.5338 17.9106 15.7644 20 12.5 20C8.35812 20 5 16.6419 5 12.5C5 8.35812 8.35812 5 12.5 5C14.4119 5 16.1513 5.72125 17.4756 6.89937L21.0112 3.36375C18.7787 1.28312 15.7925 0 12.5 0C5.59688 0 0 5.59688 0 12.5C0 19.4031 5.59688 25 12.5 25C19.4031 25 25 19.4031 25 12.5C25 11.6619 24.9137 10.8438 24.7569 10.0519Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.44141 6.68188L5.54828 9.69375C6.65953 6.9425 9.35078 5 12.5002 5C14.412 5 16.1514 5.72125 17.4758 6.89937L21.0114 3.36375C18.7789 1.28312 15.7927 0 12.5002 0C7.69891 0 3.53516 2.71062 1.44141 6.68188Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5002 25C15.7289 25 18.6627 23.7643 20.8808 21.755L17.0121 18.4812C15.7151 19.4681 14.1299 20.0017 12.5002 20C9.24895 20 6.48832 17.9268 5.44832 15.0337L1.37207 18.1743C3.44082 22.2225 7.64207 25 12.5002 25Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7569 10.0519H23.75V10H12.5V15H19.5644C19.0714 16.3853 18.1833 17.5957 17.01 18.4819L17.0119 18.4806L20.8806 21.7544C20.6069 22.0031 25 18.75 25 12.5C25 11.6619 24.9137 10.8438 24.7569 10.0519Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogle);
export default __webpack_public_path__ + "static/media/iconGoogle.8fcb374f24b1a720c97dfca532a3ecbf.svg";
export { ForwardRef as ReactComponent };